import React, { useEffect } from 'react';
import {
  Avatar, List, ListItem, ListItemAvatar, ListItemText,
} from '@mui/material';
import { setLanguage, _t } from 'utils';
import { actions } from 'redux/actions';
import { LANGUAGES, ROUTE } from 'constant';

export default ({ history = {} }) => {
  const onLanguageSelect = (code) => {
    const returnURL = window.location.hash.split('returnURL=')[1];
    setLanguage(code);
    history.push(returnURL);
  };

  useEffect(() => {
    actions.common.setLayoutTitle({ layout: { title: _t('Select a Language'), menu: ROUTE.DASHBOARD.DATA_CENTERS.key } });
  }, []);

  return (
    <List>
      {LANGUAGES.map(({ code, name, image }) => (
        <ListItem button onClick={() => onLanguageSelect(code)} key={code}>
          <ListItemAvatar>
            <Avatar alt={_t(name)} src={image} />
          </ListItemAvatar>
          <ListItemText primary={_t(name)} />
        </ListItem>
      ))}
    </List>
  );
};
